<template>
  <div class="w-full">
    
    <div class="mb-6">
      <h2 class="font-semibold text-lg text-black">Requerimientos</h2>
    </div>

    <!-- Primera fila: Selectores y Presupuesto - Desktop 3 columnas, Mobile 1 columna -->
    <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
      <!-- Tipo de propiedad -->
      <div>
        <label class="block mb-2 text-sm font-medium text-custom_gray">
          Tipo de propiedad*
        </label>
        <select
          class="bg-white h-11 border border-gray-300 text-gray-500 text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5"
          v-model="type_property_id"
        >
          <option value="" disabled>Selecciona tipo de propiedad</option>
          <option
            v-for="option in dic_properties"
            :key="option.value"
            :value="option.value"
          >
            {{ option.name }}
          </option>
        </select>
      </div>

      <!-- Tipo de Transacción -->
      <div>
        <label class="block mb-2 text-sm font-medium text-custom_gray">
          Tipo de Transacción*
        </label>
        <select
          class="bg-white h-11 border border-gray-300 text-gray-500 text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5"
          v-model="type_movement_id"
          >
          <option value="" disabled>Selecciona una opción</option>
          <option
            v-for="option in dic_movements"
            :key="option.value"
            :value="option.value"
          >
            {{ option.name }}
          </option>
        </select>
      </div>

      <!-- Presupuesto -->
      <div>
        <PriceInput
          label="Aproximado del Presupuesto"
          v-model="budget"
          :currency="budgetCurrency"
          :currency-options="currencyOptions"
          input-id="budget-currency-input"
          placeholder="Ingresa el precio aproximado"
          :required="true"
          dropdown-align="right"
          @update:currency="selectBudgetCurrency"
        />
      </div>
    </div>

    <!-- Tercera fila: Contadores - Desktop 3 columnas, Mobile 1 columna -->
    <div class="sm:flex grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6">
      <!-- Recámaras -->
      <div>
        <label class="block mb-2 text-sm font-medium text-custom_gray">
          Recámaras*
        </label>
        <div class="flex items-center border border-gray-300 rounded-lg overflow-hidden w-full sm:max-w-[8rem]">
          <button type="button" @click="decrement('bedrooms')" class="bg-gray-100 hover:bg-gray-200 border border-gray-300 rounded-s-lg p-3 h-9 focus:outline-none focus:ring-2 focus:ring-gray-100">
            <svg class="w-3 h-3 text-custom_gray" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 2"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 1h16"/></svg>
          </button>
          <input 
            type="text" 
            v-model="bedrooms" 
            @input="sanitize('bedrooms')" 
            inputmode="numeric" 
            placeholder="0" 
            class="bg-gray-50 border-x-0 border border-gray-300 h-9 text-center text-custom_gray text-sm focus:ring-0 focus:border-gray-300 block w-full py-2.5" 
          />
          <button type="button" @click="increment('bedrooms')" class="bg-gray-100 hover:bg-gray-200 border border-gray-300 rounded-e-lg p-3 h-9 focus:outline-none focus:ring-2 focus:ring-gray-100">
            <svg class="w-3 h-3 text-custom_gray" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 1v16M1 9h16"/></svg>
          </button>
        </div>
      </div>

      <!-- Baños Completos -->
      <div>
        <label class="block mb-2 text-sm font-medium text-custom_gray">
          Baños Completos*
        </label>
        <div class="flex items-center border border-gray-300 rounded-lg overflow-hidden w-full sm:max-w-[8rem]">
          <button type="button" @click="decrement('bathrooms')" class="bg-gray-100 hover:bg-gray-200 border border-gray-300 rounded-s-lg p-3 h-9 focus:outline-none focus:ring-2 focus:ring-gray-100">
            <svg class="w-3 h-3 text-custom_gray" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 2"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 1h16"/></svg>
          </button>
          <input 
            type="text" 
            v-model="bathrooms" 
            @input="sanitize('bathrooms')" 
            inputmode="numeric" 
            placeholder="0" 
            class="bg-gray-50 border-x-0 border border-gray-300 h-9 text-center text-custom_gray text-sm focus:ring-0 focus:border-gray-300 block w-full py-2.5" 
          />
          <button type="button" @click="increment('bathrooms')" class="bg-gray-100 hover:bg-gray-200 border border-gray-300 rounded-e-lg p-3 h-9 focus:outline-none focus:ring-2 focus:ring-gray-100">
            <svg class="w-3 h-3 text-custom_gray" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 1v16M1 9h16"/></svg>
          </button>
        </div>
      </div>

      <!-- Estacionamiento -->
      <div>
        <label class="block mb-2 text-sm font-medium text-custom_gray">
          Estacionamiento
        </label>
        <div class="flex items-center border border-gray-300 rounded-lg overflow-hidden w-full sm:max-w-[8rem]">
          <button type="button" @click="decrement('parking')" class="bg-gray-100 hover:bg-gray-200 border border-gray-300 rounded-s-lg p-3 h-9 focus:outline-none focus:ring-2 focus:ring-gray-100">
            <svg class="w-3 h-3 text-custom_gray" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 2"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 1h16"/></svg>
          </button>
          <input 
            type="text" 
            v-model="parking" 
            @input="sanitize('parking')" 
            inputmode="numeric" 
            placeholder="0" 
            class="bg-gray-50 border-x-0 border border-gray-300 h-9 text-center text-custom_gray text-sm focus:ring-0 focus:border-gray-300 block w-full py-2.5" 
          />
          <button type="button" @click="increment('parking')" class="bg-gray-100 hover:bg-gray-200 border border-gray-300 rounded-e-lg p-3 h-9 focus:outline-none focus:ring-2 focus:ring-gray-100">
            <svg class="w-3 h-3 text-custom_gray" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 1v16M1 9h16"/></svg>
          </button>
        </div>
      </div>
    </div>
    <div class="flex items-end justify-end mt-3">
        <button
          class="w-full font-medium sm:w-auto px-5 py-2.5 bg-tuin-100 text-white rounded-lg text-sm hover:bg-tuin_hover disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          @click="save"
          :disabled="isLoading"
        >
          {{ isLoading ? 'Guardando...' : 'Guardar' }}
        </button>
      </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, watch } from 'vue'
import PriceInput from '@/components/common/PriceInput.vue'
import axios from "axios";
import { useStore } from "vuex";

const store = useStore();
const session = computed(() => store.getters.getUserSession);
const props = defineProps({
  requirements: {
    type: Object,
    default: () => ({}),
  },
  leadId: {
    type: Number,
    required: true,
  },
});
const emit = defineEmits(['comment-saved']);
const dic_properties = ref([]);
const dic_movements = ref([]);

// Opciones de moneda
const currencyOptions = ref([
  { code: 'MXN', symbol: '$', id: 1 },
  { code: 'USD', symbol: '$', id: 2 },
  { code: 'EUR', symbol: '€', id: 3 },
])

const budgetCurrency = ref({ code: 'MXN', symbol: '$', id: 1 })

// Función para actualizar la moneda seleccionada
const selectBudgetCurrency = (currency) => {
  budgetCurrency.value = currency
}

let type_movement_id = ref(props.requirements?.type_operation_id || '');
let type_property_id = ref(props.requirements?.type_property_id || '');
let bedrooms = ref(props.requirements?.bedrooms || '');
let bathrooms = ref(props.requirements?.bathrooms || '');
let parking = ref(props.requirements?.parking || '');
let budget = ref(props.requirements?.budget || '');
let isLoading = ref(false);
let errors = ref({});

// Watcher para actualizar budgetCurrency cuando cambian los requirements
watch(() => props.requirements?.currency_id, (newCurrencyId) => {
  if (newCurrencyId) {
    const foundCurrency = currencyOptions.value.find(c => c.id === newCurrencyId);
    if (foundCurrency) {
      budgetCurrency.value = foundCurrency;
    }
  }
}, { immediate: true });
  
const numericRefs = {
  bedrooms,
  bathrooms,
  parking
};

async function getDicTypeMovement() {
  let url = `${process.env.VUE_APP_API_BASE_URL}/catalogue/type_movement_property`;
  let options = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const response = await axios.get(url, options);

  if (response.status == 401) {
    store.dispatch("clearUserSession");
  }

  if (response.status == 200) {
    const formattedData = response.data.resp.map((item) => ({
      value: item.id,
      name: item.name,
    }));
    dic_movements.value = formattedData;
  }
}

async function getDicProperties() {
  let url = `${process.env.VUE_APP_API_BASE_URL}/catalogue/type_property`;
  let options = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const response = await axios.get(url, options);

  if (response.status == 401) {
    store.dispatch("clearUserSession");
  }

  if (response.status == 200) {
    const formattedData = response.data.resp.map((item) => ({
      value: item.id,
      name: item.name,
    }));
    dic_properties.value = formattedData;
  }
}

function sanitize(refName){
  const r = numericRefs[refName];
  if(!r) return;
  const cleaned = String(r.value).replace(/[^0-9]/g,'');
  r.value = cleaned === '' ? '' : String(parseInt(cleaned,10));
}
function increment(refName){
  const r = numericRefs[refName];
  if(!r) return;
  const current = parseInt(r.value,10) || 0;
  r.value = current + 1;
}
function decrement(refName){
  const r = numericRefs[refName];
  if(!r) return;
  const current = parseInt(r.value,10) || 0;
  const next = current - 1;
  r.value = next < 0 ? 0 : next;
}

async function save() {
  errors.value = {};

  if (isLoading.value) return;
  isLoading.value = true;

  let form_post = {
    id: props.requirements?.id || null,
    lead_id: props.leadId,
    type_operation_id: type_movement_id.value,
    type_property_id: type_property_id.value,
    budget: budget.value,
    currency_id: budgetCurrency.value.id,
    bedrooms: bedrooms.value,
    bathrooms: bathrooms.value,
    parking: parking.value,
  };

  let options = {
    headers: {
      Authorization: `Bearer ${session.value.token_api}`,
    },
  };

  let url_link, method;
  
  if (props.requirements && props.requirements.id) {
    url_link = `${process.env.VUE_APP_API_BASE_URL}/broker/lead/update/requirements/${props.requirements.id}`;
    method = 'put';
  } else {
    url_link = `${process.env.VUE_APP_API_BASE_URL}/broker/lead/add/requirements`;
    method = 'post';
  }

  try {
    const response = await axios[method](url_link, form_post, options);

    if (response.status === 200) {
      emit('requirements-saved', response.data);
    }
  } catch (error) {
    console.error('Error al guardar los datos:', error);
  } finally {
    isLoading.value = false;
  }
}

onMounted(async () => {
  await getDicProperties();
  await getDicTypeMovement();
});
</script>